$(document).on('ready', function () {
    $('body').on('mousedown touchstart', '.password-preview', function() {
        var passwordFieldFor = $(this).data('for');
        $('#' + passwordFieldFor).attr('type', 'text');
    }).on('mouseup touchend touchcancel', '.password-preview', function() {
        var passwordFieldFor = $(this).data('for');
        $('#' + passwordFieldFor).attr('type', 'password');
    });
});
